export { default as getQueryName } from './getQueryName';
